import {
  NOTIFICATION_ACTION_TYPES,
  createNotificationAction,
} from "shared/ui/notifications/notification-generic/base-parts/actions";
import { formatMoneyCents } from "shared/lib/helpers/numbers";
import { NotificationBase } from "@/modules/notifications/notification/base";

import { NotificationI } from "@/lib/types/notification";
import { openAccountDetails } from "@/helpers/account-details";

export const NotificationMeetingDisputePaidOut = (
  props: NotificationI & { className?: string }
) => {
  const {
    id,
    campaign_id,
    account_id,

    campaign_name,
    account_name,
    payout_amount,

    is_seen,
    created_at,
    className,
  } = props;

  return (
    <NotificationBase
      id={id}
      isUnread={!is_seen}
      className={className}
      avatar={props}
      description={{
        text: (
          <>
            The dispute on your meeting with <b>{account_name}</b> (
            <b>{campaign_name}</b>) was not upheld.{" "}
            {payout_amount != null && (
              <>
                <b>{formatMoneyCents(payout_amount)}</b> has been paid out.{" "}
              </>
            )}
            🎉
          </>
        ),
        date: created_at,
        campaignName: campaign_name,
      }}
      actions={[
        createNotificationAction(
          NOTIFICATION_ACTION_TYPES.PRIMARY,
          "View account",
          () => {
            openAccountDetails({
              campaignId: campaign_id,
              accountId: account_id,
            });
          }
        ),
      ]}
    />
  );
};
